<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <nj-form-item [hasError]="(this.Instruction.units ?? '') == ''" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isRequired]="true" [isFloatingLabel]="true" iconName="keyboard_arrow_down" [isSelect]="true"
                inputId="BMUs">
                <select njFormField id="BMUs" [(ngModel)]="Instruction.units">
                    <option *ngFor="let unit of BMUList" value='{{unit}}'>{{unit}}</option>
                </select>
                <ng-container njFormLabel>Unit</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">
        <div class="col-md-2">
            <nj-form-item [hasError]="(this.Instruction.issuedFrom ?? '') == ''" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EventStartTime" [isRequired]="true">
                <input type="date" id="EventStartTime" njFormField [(ngModel)]="Instruction.issuedFrom" />
                <ng-container njFormLabel>Issued From</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EvenEndTime">
                <input type="date" id="EventEndTime" njFormField [(ngModel)]="Instruction.issuedTo" />
                <ng-container njFormLabel>Issued To</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-6">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="dateComments" [isRequired]="false">
                <input type="text" id="dateComments" njFormField [(ngModel)]="Instruction.dateComment" />
                <ng-container njFormLabel>Date Comments</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <nj-form-item [hasError]="(this.Instruction.subject ?? '') == ''" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="subject" [isRequired]="true">
                <input type="text" id="subject" njFormField [(ngModel)]="Instruction.subject" />
                <ng-container njFormLabel>Subject</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" inputId="Details">
                <textarea id="Details" [(ngModel)]="Instruction.details" njFormField maxlength="1000"></textarea>
                <ng-container njFormLabel>Details</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row" [style]="'margin-top: 20px;'">
        Attachments
    </div>
    <div class="row" [style]="'margin-bottom: 5px;'">
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="file" [isRequired]="true">
                <input type="file" id="file" njFormField (change)="onFileSelected($event)" />
                <ng-container njFormLabel>File</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-2" [style]="'margin-top: 10px;'">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="AddFile()">
                Add File
            </nj-button>
        </div>
    </div>
    <div class="row">
        <table id="Attachments" class="nj-table nj-table--hover nj-table--striped nj-cursor">
            <thead>
                <tr [style]="'background-color: #d8d8d8'">
                    <th>File</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (file of Instruction.files; track file; let ix = $index) {
                <tr>
                    <td>{{file.fileName}}</td>
                    <td>
                        <nj-button size="normal" type="button" icon="" [hasCustomIcon]="false"
                            (buttonClick)="DownloadFile(file.fileId, file.fileName)">
                            Download
                        </nj-button>
                        <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                            (buttonClick)="RemoveFile(ix)">
                            Delete
                        </nj-button>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    <div class="row">
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="SaveInstruction()">
                Save
            </nj-button>
        </div>
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                [style]="'margin-top: 10px;'" (buttonClick)="Cancel()">
                Cancel
            </nj-button>
        </div>
    </div>
</div>